import React from 'react';

import { Name as PlanName } from '@portal/components/plan/name';
import { UpcomingSubscriptionDetailsFragment } from '@portal/schema';

export const Name: React.FC<{ subscription: UpcomingSubscriptionDetailsFragment }> = ({ subscription }) => (
  <PlanName plan={subscription.pricing.plan} quantity={subscription.quantity} />
);
